import type { CrmOrganizationUnitListParams, CrmOrganizationUnitStatus, CrmOrganizationUnitType } from "../types";

export const crmOrganizationUnitDefaultListParams: CrmOrganizationUnitListParams = {
  page: 1,
  pageSize: 20,
  sortField: "updated_at",
  sortDirection: "desc",
};

export const crmOrganizationUnitPageSizeOptions = [10, 20, 50, 100];

export const crmOrganizationUnitTypeOptions: CrmOrganizationUnitType[] = ["二级学院", "系", "专业"];

export const crmOrganizationUnitStatusOptions: CrmOrganizationUnitStatus[] = [
  "有效",
  "停用",
  "合并",
  "撤销",
];
